export { default as ForwardIcon } from './ForwardIcon';
